import OstroChatIcon from '../icons/OstroChatIcon';

export default function OstroChatAvatar({ src }: { src?: string }) {
  return (
    <span
      data-testid="ostro-chat-avatar"
      className="rounded-full bg-white w-[24px] h-[24px] flex items-center justify-center"
    >
      {src ? (
        <img
          className="rounded-full w-[24px] h-[24px] object-cover"
          src={src}
          alt="Ostro Chat Avatar"
        />
      ) : (
        <OstroChatIcon />
      )}
    </span>
  );
}
